<template>
    <form
        class="flex flex-wrap border border-gray-200 rounded py-3 px-4"
        @submit.prevent="saveKeluarga"
    >
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="w-full"
                        for="nama_lengkap"
                        value="Nama Lengkap"
                    />

                    <InputDataGrid
                        ref="pegawaiInputDataGrid"
                        :config="pegawaiInputDataGridConfig"
                        :error="form.errors.pegawai_id"
                        :disabled="form.id"
                        @getInputDataGrid="getInputDataGridPegawai"
                    />
                    <InputError
                        :message="form.errors.pegawai_id"
                        class="mt-2"
                    />
                </div>
            </div>
        </div>
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="mt-3 w-full"
                        for="nama_anggota_keluarga"
                        value="Nama Anggota Keluarga"
                    />
                    <Input
                        id="nama_anggota_keluarga"
                        v-model="form.nama_anggota_keluarga"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{
                            'p-invalid': form.errors.nama_anggota_keluarga,
                        }"
                    />
                    <InputError
                        :message="form.errors.nama_anggota_keluarga"
                        class="mt-2"
                    />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="mt-3 w-full"
                        for="stts_anggota_keluarga_opt"
                        value="Stts Anggota Keluarga"
                    />
                    <Select
                        id="stts_anggota_keluarga_opt"
                        class="mt-1 block w-full"
                        :class="{
                            'p-invalid': form.errors.stts_anggota_keluarga,
                        }"
                        :options="$page.props.options.stts_anggota_keluarga_opt"
                        v-model="form.stts_anggota_keluarga"
                    />
                    <InputError
                        :message="form.errors.stts_anggota_keluarga"
                        class="mt-2"
                    />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="mt-3 w-full"
                        for="tgl_lahir_anggota_keluarga"
                        value="Tgl Lahir Anggota Keluarga"
                    />
                    <Calendar
                        id="tgl_lahir_anggota_keluarga"
                        v-model="form.tgl_lahir_anggota_keluarga"
                        autocomplete="off"
                        class="mt-1 block w-full"
                        :class="{
                            'p-invalid': form.errors.tgl_lahir_anggota_keluarga,
                        }"
                        dateFormat="yy-mm-dd"
                        @date-select="selectDate"
                    />
                    <InputError
                        :message="form.errors.tgl_lahir_anggota_keluarga"
                        class="mt-2"
                    />
                </div>
                <div class="field w-full px-3 mb-3">
                    <Alert
                        :type="'warning'"
                        :header="'Perhatian'"
                        :msg="
                            'Tunjangan anak dibayar sampai dengan umur ' +
                            max_umur_anak_dihitung_tunjangan +
                            ' tahun, dan akan dibayar sampai umur ' +
                            max_umur_anak_dihitung_tunjangan_final +
                            ' tahun jika melampirkan surat keterangan masih kuliah/sekolah'
                        "
                    />
                </div>
                <div class="field w-full px-3 mb-3">
                    <InlineMessage severity="info"
                        >Umur : <span>{{ form.umur }}</span></InlineMessage
                    >
                </div>
                <div
                    class="field w-full px-3 mb-3"
                    v-show="
                        form.stts_anggota_keluarga ==
                            sttsAnggotaKeluarga.ANAK &&
                        selected_pegawai_is_dibayar_tunj &&
                        is_umur_valid_to_show
                    "
                >
                    <JetLabel
                        class="mt-3 w-full"
                        for="is_dihitung_tunjangan_anak_force"
                        value="Tunj Anak"
                    />
                    <JetLabel
                        class="w-full text-red-500"
                        for="is_dihitung_tunjangan_anak_force"
                        :value="
                            '* Dipilih jika ingin tunj anak dibayarkan s/d umur ' +
                            max_umur_anak_dihitung_tunjangan_final +
                            ' tahun'
                        "
                    />
                    <Checkbox
                        id="is_dihitung_tunjangan_anak_force"
                        v-model="form.is_dihitung_tunjangan_anak_force"
                        :binary="true"
                    />
                    <InputError
                        :message="form.errors.is_dihitung_tunjangan_anak_force"
                        class="mt-2"
                    />
                </div>
            </div>
        </div>
        <div class="lg:w-full md:w-full">
            <div class="flex flex-col mb-6">
                <div class="w-full px-3 text-center">
                    <InertiaButtonEdit
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Data"
                        v-if="form.id"
                    />
                    <InertiaButtonSave
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Baru"
                        v-else
                    />
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { defineComponent } from "vue";
import Checkbox from "primevue/checkbox";
import ButtonSave from "@/Components/ButtonSave";
import JetButton from "@/Jetstream/Button.vue";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import Select from "@/Components/Select";
import InputDataGrid from "@/Components/InputDataGrid";
import Calendar from "primevue/calendar";
import InlineMessage from "primevue/inlinemessage";
import moment from "moment";
import Alert from "@/Components/Alert";
import { SttsAnggotaKeluarga, Pegawai } from "@/constants";

const totalRowShowed = 5;

export default defineComponent({
    props: ["selectedData"],
    components: {
        Checkbox,
        ButtonSave,
        JetButton,
        JetLabel,
        Input,
        InputError,
        InertiaButtonSave,
        InertiaButtonEdit,
        Select,
        InputDataGrid,
        Calendar,
        InlineMessage,
        Alert,
    },
    data() {
        return {
            pegawaiInputDataGridConfig: {
                table: "pegawai",
                formName: "nama_lengkap",
                defineCols: [
                    {
                        field: "nip",
                        header: "NIP",
                        style: "max-width: 15rem",
                    },
                    {
                        field: "nama_lengkap",
                        header: "Nama",
                        style: "max-width: 25rem",
                    },
                ],
                dtSourceApiRoute: {
                    list: "keluarga.pegawai",
                },
            },
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                pegawai_id: null,
                nama_lengkap: null,
                nama_anggota_keluarga: null,
                tgl_lahir_anggota_keluarga: null,
                stts_anggota_keluarga:
                    this.$page.props.options.stts_anggota_keluarga_opt[0],
                is_dihitung_tunjangan_anak_force: null,
                umur: null,
            }),
            sttsAnggotaKeluarga: SttsAnggotaKeluarga,
            selected_pegawai_is_dibayar_tunj: false,
            is_umur_valid_to_show: false,
            max_umur_anak_dihitung_tunjangan:
                Pegawai.MAX_UMUR_ANAK_DIHITUNG_TUNJANGAN,
            max_umur_anak_dihitung_tunjangan_final:
                Pegawai.MAX_UMUR_ANAK_DIHITUNG_TUNJANGAN_FINAL,
        };
    },
    mounted() {
        //
    },
    computed: {
        //
    },
    watch: {
        // whenever question changes, this function will run
        selectedData(newSelectedData, oldSelectedData) {
            this.resetForm();
        },
        "form.umur": function (newUmur, oldUmur) {
            this.is_umur_valid_to_show = false;
            if (newUmur > Pegawai.MAX_UMUR_ANAK_DIHITUNG_TUNJANGAN) {
                this.is_umur_valid_to_show = true;
                if (newUmur > Pegawai.MAX_UMUR_ANAK_DIHITUNG_TUNJANGAN_FINAL) {
                    this.is_umur_valid_to_show = false;
                }
            }
        },
    },
    methods: {
        showForceBayarTunj: function (value) {},
        selectDate: function (value) {
            let umur = moment().diff(value, "years");
            this.form.umur = umur;
        },
        addItem: function () {
            //
        },
        getInputDataGridPegawai: function (inputData) {
            this.form.pegawai_id = inputData.id;
        },
        populateEdit: function (keluarga) {
            // console.log("keluarga", keluarga);
            this.form.id = keluarga.id;
            this.form.pegawai_id = keluarga.pegawai_id;
            this.form.nama_lengkap = keluarga.pegawai.nama_lengkap;
            this.form.nama_anggota_keluarga = keluarga.nama_anggota_keluarga;
            this.form.tgl_lahir_anggota_keluarga = moment(
                keluarga.tgl_lahir_anggota_keluarga
            ).toDate();
            this.form.stts_anggota_keluarga = keluarga.stts_anggota_keluarga;
            this.form.is_dihitung_tunjangan_anak_force =
                keluarga.is_dihitung_tunjangan_anak_force == 1 ? true : false;
            this.form.umur = keluarga.umur;

            this.selected_pegawai_is_dibayar_tunj =
                keluarga.pegawai.is_dibayar_tunj == 1 ? true : false;
            this.$refs.pegawaiInputDataGrid.setData(keluarga);
        },
        resetForm: function (event) {
            this.form.id = null;
            this.form.pegawai_id = null;
            this.form.nama_lengkap = null;
            this.form.no_rekening = null;
            this.form.nama_anggota_keluarga = null;
            this.form.tgl_lahir_anggota_keluarga = null;
            this.form.stts_anggota_keluarga =
                this.$page.props.options.stts_anggota_keluarga_opt[0];
            this.form.is_dihitung_tunjangan_anak_force = null;
            this.form.umur = null;
            // this.form.reset();

            this.$refs.pegawaiInputDataGrid.clear();
            this.form.clearErrors();
        },
        saveKeluarga: function (event) {
            let self = this;
            this.form.post(route("keluarga.store"), {
                errorBag: "saveKeluarga",
                preserveScroll: true,
                onSuccess: () => {
                    if (self.form.id) {
                        self.$emit("changeData", self.form);
                    } else {
                        self.$emit("loadData");
                        self.resetForm();
                    }

                    // self.$emit("loadData");
                    // self.resetForm();
                },
                onFinish: () => {
                    //
                },
            });
        },
    },
});
</script>